<header class="background-header">
	<img src="../../assets/img/{{themeService.theme}}/header-background.svg" alt="" class="background-header-img" [ngClass]="{backgroundWidth: themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
</header>
<section class="main-side-nav" [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
	<section class="container request-access-plan-container">
		<section class="dynamic-collapse">
			<div class="dynamic-collapse-header">
				<h3 class="request-access-title">Tell us about the plan you wish to access</h3>
			</div>
			<section class="dynamic-collapse-main">
				<form [formGroup]="requestAccessFormGroup" class="form-account about-me-form">
					<div class="dynamic-collapse-content">
						<section class="floating-form">
							<section class="fields-container">
								<div class="form-group floating-label">
									<label class="label">
										<input type="text" class="form-control floating-input" placeholder=" " required
											formControlName="firstName"
											[ngClass]="{'is-invalid': submitted && f.firstName.errors}">
										<span class="highlight"></span>
										<label class="effect-label">Plan owner's first name</label>
									</label>
									<div *ngIf="submitted && f.firstName.errors" class="invalid-feedback">
										<div *ngIf="f.firstName.errors.required">First name is required</div>
									</div>
								</div>
	
								<div class="form-group floating-label">
									<label class="label">
										<input type="text" class="form-control floating-input" placeholder=" " required
											formControlName="lastName"
											[ngClass]="{'is-invalid': submitted && f.lastName.errors}">
										<span class="highlight"></span>
										<label class="effect-label">Plan owner's last name</label>
									</label>
									<div *ngIf="submitted && f.lastName.errors" class="invalid-feedback">
										<div *ngIf="f.lastName.errors.required">Last name is required</div>
									</div>
								</div>
							</section>
							
							<section class="fields-container">
								<div class="form-group floating-label">
									<label class="label">
										<input type="text" class="form-control floating-input" placeholder=" " required
											formControlName="email" [ngClass]="{'is-invalid': submitted && f.email.errors}">
										<span class="highlight"></span>
										<label class="effect-label">Plan owner's email</label>
									</label>
									<div *ngIf="submitted && f.email.errors" class="invalid-feedback">
										<div *ngIf="f.email.errors.required">Email is required</div>
										<div *ngIf="f.email.errors.email">Email must be a valid email address</div>
									</div>
								</div>
	
								<div class="choice-report-container">
									<app-dynamic-dropdown formControlName="choiceReport"
										[myLabel]="'What do you wish to report?'" [id]="choiceReport" [optionCollection]="choiceReport"
										[optionViewProperty]="opt" [optionValueProperty]="opt">
									</app-dynamic-dropdown>
									<div *ngIf="submitted && f.choiceReport.errors" class="invalid-feedback">
										<div *ngIf="f.choiceReport.errors.required">Report is required</div>
									</div>
								</div>
							</section>
							

							<h4 class="col about-you">Tell us about you</h4>

							<section class="fields-container">
								<div class="form-group floating-label">
									<label class="label">
										<input type="text" class="form-control floating-input" placeholder=" " required
											formControlName="relationToOwner"
											[ngClass]="{'is-invalid': submitted && f.relationToOwner.errors}">
										<span class="highlight"></span>
										<label class="effect-label">Plan owner's relation to you</label>
									</label>
									<div *ngIf="submitted && f.relationToOwner.errors" class="invalid-feedback">
										<div *ngIf="f.relationToOwner.errors.required">Relation is required</div>
									</div>
								</div>
								<div class="form-group floating-label">
									<label class="label">
										<input type="text" class="form-control floating-input" placeholder=" " required
											formControlName="phoneNumber"
											[ngClass]="{'is-invalid': submitted && f.phoneNumber.errors}">
										<span class="highlight"></span>
										<label class="effect-label">Your phone number</label>
									</label>
									<div *ngIf="submitted && f.phoneNumber.errors" class="invalid-feedback">
										<div *ngIf="f.phoneNumber.errors.required">Phone number is required</div>
									</div>
								</div>
							</section>
							
							<div class="form-group" style="padding: 0 !important;">
								<app-file-upload [itemId]="sharedPlanClientId" formControlName="fileDelegateId">
								</app-file-upload>
							</div>
							<div class="form-group">
								<input type="button"
									class="btn btn-primary primary-default-btn submit-request"
									value="Submit Request" (click)="onSubmit()">
							</div>
						</section>
					</div>
				</form>
			</section>
		</section>
	</section>
</section>